import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RotateCcw, CheckCircle2, Clock, AlertTriangle } from "lucide-react";
import api from "../lib/api";

const STATUS = {
  refunded: { label: "Rimborsato", cls: "bg-emerald-100 text-emerald-800 border-emerald-200", Icon: CheckCircle2 },
  authorization_cancelled: { label: "Blocco carta annullato", cls: "bg-emerald-100 text-emerald-800 border-emerald-200", Icon: CheckCircle2 },
  manual: { label: "Rimborso manuale in corso", cls: "bg-amber-100 text-amber-800 border-amber-200", Icon: Clock },
  failed: { label: "Errore · in gestione", cls: "bg-red-100 text-red-800 border-red-200", Icon: AlertTriangle },
};
const METHOD = { card: "Carta", bank_transfer: "Bonifico", paypal: "PayPal" };

export default function RefundsHistory() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/me/refunds").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  const total = (items || []).filter(r => ["refunded", "authorization_cancelled"].includes(r.status)).reduce((a, r) => a + r.amount, 0);
  return (
    <div data-testid="refunds-panel">
      <div className="ga-card p-5 flex flex-wrap items-center gap-4 mb-5">
        <RotateCcw className="w-5 h-5 text-slate-700" />
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Rimborsi ricevuti</div>
          <div className="font-display text-3xl font-extrabold text-slate-900">€ {total.toFixed(2)}</div>
        </div>
        <div className="text-sm text-slate-600">{(items || []).length} contestazion{(items || []).length === 1 ? "e accolta" : "i accolte"}</div>
      </div>
      {items === null && <div className="text-sm text-slate-500 py-6">Caricamento...</div>}
      {items && items.length === 0 && <div className="ga-card p-8 text-center text-sm text-slate-500" data-testid="refunds-empty">Nessun rimborso finora.</div>}
      <div className="space-y-3">
        {(items || []).map(r => {
          const st = STATUS[r.status] || STATUS.manual;
          return (
            <Link to={`/ordine/${r.order_id}`} key={`${r.order_id}-${r.created_at}`} className="ga-card p-5 block hover:border-slate-400" data-testid={`refund-${r.order_id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <div className="font-semibold text-slate-900 truncate">{r.order_title}</div>
                  <div className="text-xs font-mono text-slate-500 mt-0.5">{r.supplier_name} · {METHOD[r.method] || r.method} · {r.created_at ? new Date(r.created_at).toLocaleDateString("it-IT") : ""}</div>
                  {r.dispute_reason && <div className="text-xs text-slate-600 mt-1 line-clamp-2">Motivo: "{r.dispute_reason}"</div>}
                </div>
                <div className="text-right shrink-0">
                  <div className="font-mono font-bold text-lg text-slate-900">€ {r.amount.toFixed(2)}</div>
                  <span className={`inline-flex items-center gap-1 mt-1 px-2 py-0.5 rounded-full border text-[10px] font-bold ${st.cls}`} data-testid={`refund-status-${r.order_id}`}>
                    <st.Icon className="w-3 h-3" /> {st.label}
                  </span>
                </div>
              </div>
              {(r.reference || r.note || r.error) && <div className="mt-2 text-[11px] font-mono text-slate-500 break-all">{r.error || r.note || r.reference}</div>}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
